/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { DivideIcon16Light } from './DivideIcon16Light';
import { DivideIcon16Regular } from './DivideIcon16Regular';
import { DivideIcon16Solid } from './DivideIcon16Solid';
import { DivideIcon20Light } from './DivideIcon20Light';
import { DivideIcon20Regular } from './DivideIcon20Regular';
import { DivideIcon20Solid } from './DivideIcon20Solid';
import { DivideIcon24Regular } from './DivideIcon24Regular';
import { DivideIcon24Solid } from './DivideIcon24Solid';
import { DivideIcon32Regular } from './DivideIcon32Regular';
import { DivideIcon64Regular } from './DivideIcon64Regular';
var sizes = {
    16: {
        light: DivideIcon16Light,
        regular: DivideIcon16Regular,
        solid: DivideIcon16Solid,
    },
    20: {
        light: DivideIcon20Light,
        regular: DivideIcon20Regular,
        solid: DivideIcon20Solid,
    },
    24: {
        regular: DivideIcon24Regular,
        solid: DivideIcon24Solid,
    },
    32: {
        regular: DivideIcon32Regular,
    },
    64: {
        regular: DivideIcon64Regular,
    },
};
export var DivideIcon = forwardRef('DivideIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
